module.exports = __webpack_public_path__ + "static/media/sprite_5.f3bbe590.png";